// extracted by mini-css-extract-plugin
export default {"intro":"Introduction_intro__ShwzV","hide":"Introduction_hide__2Q4Im","btnDown":"Introduction_btnDown__XhSwg","show":"Introduction_show__iGvhR"};